import {getCardActivityService} from '../services/components/get_cardactivity.jsx'

export const getCardActivity = (cardDetailId, startDate, endDate, statementPeriod,transactionType) => dispatch => {
    let state = ""
    getCardActivityService ((data, msg , status) =>{
        if(msg === "success"){
            state={
                message: "Success",
                status: 200,
                body: data
            }
        } else {
            state = data
        }
        dispatch({ type: "CARD_ACTIVITY", payload: state })
    }, cardDetailId, startDate, endDate, statementPeriod,transactionType)
    
}


// WEBPACK FOOTER //
// ./src/actions/getcardactivity.jsx